export default [
  {
    value: "name",
    text: "Name",
    width: 250,
    sortable: true,
  },
  {
    value: "serial",
    text: "Kit Serial #",
    width: 110,
    sortable: true,
  },
  {
    value: "status",
    text: "Status",
    width: 110,
    sortable: true,
  },
  {
    value: "alarms",
    text: "Alarms",
    width: 110,
    sortable: false,
  },
  {
    value: "tags",
    text: "Tags",
    width: 50,
    sortable: false,
  },
  {
    value: "routerSerial",
    text: "Router Serial #",
    width: 110,
    sortable: false,
  },
  {
    value: "sims",
    text: "SIMs",
    width: 110,
    sortable: false,
  },
  {
    value: "nvrVersion",
    text: "NVR Version",
    width: 40,
    align: "center",
    sortable: false,
  },
  {
    value: "nvrSerial",
    text: "NVR Serial #",
    width: 110,
    sortable: false,
  },
  {
    value: "nvrModel",
    text: "NVR Model",
    width: 40,
    align: "center",
    sortable: true,
  },
  {
    value: "nvrDeviceType",
    text: "SBC Type",
    width: 40,
    align: "center",
    sortable: false,
  },
  {
    value: "projectName",
    text: "Project",
    width: 160,
    sortable: true,
  },
  {
    value: "countryId",
    text: "Country",
    width: 110,
    sortable: true,
  },
  {
    value: "powerType",
    text: "Power Type",
    width: 110,
    sortable: true,
  },
  {
    value: "createdAt",
    text: "Created At",
    width: 150,
    sortable: true,
  },
]
